import { Directive, ElementRef, HostListener } from "@angular/core";
import { GLTFLoader } from "./scene-loader";
import { RenderLoop } from "../game-engine/render-loop";
import { SceneRenderer } from "../renderers/scene-renderer";
var WEBGL2_EXTENSIONS = ["OES_texture_float_linear"];
var Webgl2Directive = (function () {
    function Webgl2Directive(canvas_ref_, gltf_loader_, render_loop_) {
        this.canvas_ref_ = canvas_ref_;
        this.gltf_loader_ = gltf_loader_;
        this.render_loop_ = render_loop_;
        this.enabled_extensions = new Map();
    }
    ;
    Webgl2Directive.prototype.onContextLost = function (event) {
        console.log("context lost");
        return false;
    };
    ;
    Webgl2Directive.prototype.onContextRestored = function (event) {
        if (this.createContext()) {
        }
        ;
        console.log("context restored");
        return false;
    };
    ;
    Webgl2Directive.prototype.createContext = function () {
        var _this = this;
        var html_canvas = this.canvas_ref_.nativeElement;
        this.render_context = html_canvas.getContext("webgl2");
        if (this.render_context) {
            this.setExtensionAvailabilty();
            WEBGL2_EXTENSIONS.forEach(function (extension) {
                _this.enableExtension(extension);
            });
            this.render_context.clearColor(0.7, 0.7, 0.7, 1.0);
            this.render_context.clearDepth(1.0);
            this.render_context.enable(this.render_context.DEPTH_TEST);
            this.render_context.depthFunc(this.render_context.LEQUAL);
            this.gltf_loader_.fetchGLTFData("test-scene.gltf", this.render_context).subscribe(function (result) {
                _this.scene_renderer_ = _this.gltf_loader_.getItem(SceneRenderer);
                _this.begin();
            });
            return true;
        }
        else {
            console.log("Unable to initialise Webgl2.");
            return false;
        }
    };
    ;
    Webgl2Directive.prototype.begin = function () {
        var _this = this;
        this.scene_renderer_.constructScene();
        this.update_sub_ = this.render_loop_.update_events
            .subscribe(function (dt) {
            _this.update(dt);
        });
        this.render_sub_ = this.render_loop_.render_events
            .subscribe(function (factor) {
            _this.draw();
        });
        this.render_loop_.begin();
    };
    ;
    Webgl2Directive.prototype.update = function (dt) {
        this.scene_renderer_.updateScene(dt);
    };
    ;
    Webgl2Directive.prototype.draw = function () {
        this.render_context.clear(this.render_context.COLOR_BUFFER_BIT | this.render_context.DEPTH_BUFFER_BIT);
        this.render_context.viewport(0, 0, this.render_context.drawingBufferWidth, this.render_context.drawingBufferHeight);
        this.scene_renderer_.drawObjects();
    };
    ;
    Webgl2Directive.prototype.isExtensionEnabled = function (extension) {
        return this.enabled_extensions.get(extension);
    };
    ;
    Webgl2Directive.prototype.enableExtension = function (extension) {
        if (this.supported_extensions.findIndex(function (x) { return x == extension; }) != -1) {
            this.render_context.getExtension(extension);
            this.enabled_extensions.set(extension, true);
        }
        else {
            console.log("Webgl extension, " + extension + ", is not supported.");
        }
    };
    ;
    Webgl2Directive.prototype.setExtensionAvailabilty = function () {
        this.supported_extensions = this.render_context.getSupportedExtensions();
        for (var i in this.supported_extensions) {
            this.enabled_extensions.set(this.supported_extensions[i], false);
        }
    };
    ;
    Webgl2Directive.prototype.ngOnDestroy = function () {
        this.render_loop_.stop();
        this.update_sub_ && this.update_sub_.unsubscribe();
        this.render_sub_ && this.render_sub_.unsubscribe();
    };
    ;
    Webgl2Directive.decorators = [
        { type: Directive, args: [{
                    selector: "[webgl2]"
                },] },
    ];
    Webgl2Directive.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: GLTFLoader, },
        { type: RenderLoop, },
    ]; };
    Webgl2Directive.propDecorators = {
        "onContextLost": [{ type: HostListener, args: ["webglcontextlost", ["$event"],] },],
        "onContextRestored": [{ type: HostListener, args: ["webglcontextrestored", ["$event"],] },],
    };
    return Webgl2Directive;
}());
export { Webgl2Directive };
//# sourceMappingURL=webgl2.directive.js.map